export default "__VITE_ASSET__CqXkNlCE__"